import { api } from './client';
import { endpoints } from './endpoints';

export function listUniversities(q) {
  return api.get(endpoints.catalog.universities, { params: q ? { q } : {} });
}

export function listIndustries() {
  return api.get(endpoints.catalog.industries);
}

export function listJobCategories() {
  return api.get(endpoints.catalog.jobCategories);
}

/** `limit` is optional; the API caps it at 100 and defaults to 30. */
export function listSkills(q, limit) {
  return api.get(endpoints.catalog.skills, {
    params: { ...(q ? { q } : {}), ...(limit ? { limit } : {}) },
  });
}

export function getPlatformStats() {
  return api.get(endpoints.catalog.stats);
}

export function listFeaturedCompanies() {
  return api.get(endpoints.catalog.featuredCompanies);
}

export function listPlans() {
  return api.get(endpoints.catalog.plans);
}

/** The fixed list of perks a company can pick for its branding page. */
export function listCompanyPerks() {
  return api.get(endpoints.catalog.companyPerks);
}
